import React, { useCallback } from 'react';

import {
  TrackingProvider as Provider,
  TrackingMiddleware,
  createEventTracker,
} from '@zapier/toolbox-tracking';

import { useFormContext } from './FormContext';

export const TrackingProvider = ({ children }) => {
  const { attemptId } = useFormContext();

  const middleware = useCallback<TrackingMiddleware>(
    () => async event => {
      event.apply({ attempt_id: attemptId });
    },
    [attemptId]
  );

  return (
    <Provider trackingFunctions={createEventTracker([middleware])}>
      {children}
    </Provider>
  );
};

export default TrackingProvider;
